import React from "react";
import KBBValueImg from "assets/img/QVLogoWhite.png";

// Define the BLACKBOOK component
const KBBValue = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://www.quickvalues.com/",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div
			onClick={openInNewTab}
			style={{ backgroundColor: "black", display: "inline-block" }}
		>
			<img src={KBBValueImg} alt="Quick Values" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default KBBValue;
